import { Users, TrendingUp, Heart, Music, ArrowRight, ArrowLeft, Quote, ChevronDown } from 'lucide-react';
import { ProgressHeader } from '../components/LandingPage/ProgressHeader';

export const LandingPage: React.FC = () => {
    const handleSignUp = () => {
        window.location.href = 'https://djdj.io/register';
    };

    const handleLogin = () => {
        window.location.href = 'https://djdj.io/login';
    };


    return (
        <>
        <ProgressHeader />
        <div className="min-h-screen pb-10 bg-gradient-to-b via-[#682598] from-gray-950  to-black text-white relative"
            style={{ fontFamily: "'AvantGarde Bk BT', sans-serif" }}
        >
            <div className="absolute inset-0 bg-black opacity-50"></div>
            
            {/* Content */}
            <div className="relative z-10">
                {/* Skylamp SVG at top middle */}
                <div className="flex justify-center">
                    <img
                        src="/skylamp.svg"
                        alt="Skylamp Logo"
                        className="h-auto w-auto"
                    />
                </div>

                    <div className="flex flex-col justify-center items-center pt-72 space-y-6">
                    {/* DjSocial with logo */}
                    <div className="flex items-center space-x-3">
                        <img
                            src="/djlogo.png"
                            alt="DJ Logo"
                            className="h-12 w-auto"
                        />
                            <h1 className="text-5xl text-center">DJ Social</h1>
                        </div>
                        <p className="text-center text-4xl">Grow your audience, while gaining revenue</p>
                        <div className="flex flex-row justify-around space-x-4">
                            <button className="text-xl text-white bg-purple-700 p-2 w-32 rounded-4xl hover:bg-blue-500" onClick={handleLogin}>Login</button>
                            <button className="text-xl text-white bg-purple-700 p-2 w-32 rounded-4xl hover:bg-blue-500" onClick={handleSignUp}>Sign Up</button>
                        </div>

                        <div className="mt-32 flex flex-col justify-center items-center space-y-4">
                            <p className="text-3xl text-white">Learn More</p>
                            <div className="animate-bounce">
                                <ChevronDown className="w-12 h-12 text-purple-400" strokeWidth={2.5} />
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="flex flex-row h-1/2 bg-black px-6">
                <div className="flex flex-col flex-grow pt-10 pb-32">
                    <h1 className="lg:text-9xl text-7xl bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent text-center">DJ Social</h1>
                    <h2 className="lg:text-7xl  text-5xl text-center">Changing live music for good</h2>
                    <div className="grid md:grid-cols-3 gap-8 mt-16 max-w-5xl mx-auto">
                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-purple-900/30 to-purple-800/20 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25">
                            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform duration-300">
                                <Users className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-2xl font-bold mb-4 text-purple-300">Engage & Interact</h3>
                            <p className="text-gray-300 leading-relaxed">
                                Connect with your audience in real-time, creating unforgettable experiences that keep them coming back for more.
                            </p>
                        </div>

                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-purple-900/30 to-purple-800/20 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25">
                            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform duration-300">
                                <TrendingUp className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-2xl font-bold mb-4 text-purple-300">Increase Tips 20-30%</h3>
                            <p className="text-gray-300 leading-relaxed">
                                Boost your earnings significantly by creating deeper connections and memorable moments with your audience.
                            </p>
                        </div>

                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-purple-900/30 to-purple-800/20 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25">
                            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform duration-300">
                                <Heart className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-2xl font-bold mb-4 text-purple-300">Grow Community</h3>
                            <p className="text-gray-300 leading-relaxed">
                                Build a stronger sense of community by bringing in your audience's opinions and making them part of the experience.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            {/* Interactive Flow Diagram */}
            <div className="relative py-20 overflow-hidden bg-black pb-32">
                <div className="relative max-w-6xl mx-auto px-6">
                    <h2 className="text-6xl font-bold text-center mb-16">How It Works</h2>

                    <div className="flex items-center justify-center gap-6 lg:gap-20">
                        {/* DJ */}
                        <div className="text-center group lg:w-44 md:w-36 w-28">
                            <div className="relative flex flex-col items-center">
                                <div className="lg:w-32 lg:h-32 md:w-24 md:h-24 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-full flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300 shadow-2xl shadow-purple-500/30 relative">
                                    <Music className="lg:w-16 lg:h-16 md:w-12 md:h-12 w-8 h-8 text-white" />
                                    <div className="absolute lg:-top-1 lg:-right-1 -top-0.5 -right-0.5 lg:w-6 lg:h-6 w-4 h-4 bg-green-500 rounded-full border-2 lg:border-4 border-black animate-pulse"></div>
                                </div>
                            </div>
                            <h3 className="lg:text-2xl text-lg font-bold text-purple-300 mb-2">DJ</h3>
                            <p className="lg:text-base text-xs text-gray-400">Creates the vibe</p>
                        </div>

                        {/* Arrows */}
                        <div className="flex flex-col items-center lg:gap-6 gap-2">
                            <div className="lg:text-sm text-xs text-purple-400 font-medium lg:px-4 px-3 py-2 bg-purple-900/30 rounded-full border border-purple-500/30">
                                1. Song request
                            </div>
                            <div className="flex items-center gap-2 animate-pulse">
                                <ArrowLeft className="lg:w-8 lg:h-8 w-4 h-4 text-purple-400" />
                                <ArrowLeft className="lg:w-6 lg:h-6 w-4 h-4 text-purple-500" />
                                <ArrowLeft className="lg:w-4 lg:h-4 w-4 h-4 text-purple-600" />
                            </div>
                            <div className="lg:text-sm text-xs text-purple-400 font-medium lg:px-4 px-3 py-2 bg-purple-900/30 rounded-full border border-purple-500/30">
                                2. Accept Song + Set Tip
                            </div>
                            <div className="flex items-center gap-2 animate-pulse">
                                <ArrowRight className="lg:w-8 lg:h-8 w-4 h-4 text-purple-400" />
                                <ArrowRight className="lg:w-6 lg:h-6 w-4 h-4 text-purple-500" />
                                <ArrowRight className="lg:w-4 lg:h-4 w-4 h-4 text-purple-600" />
                            </div>
                            <div className="lg:text-sm text-xs text-purple-400 font-medium lg:px-4 px-3 py-2 bg-purple-900/30 rounded-full border border-purple-500/30">
                                3. Accept & Send Tip
                            </div>
                            <div className="flex items-center gap-2 animate-pulse">
                                <ArrowLeft className="lg:w-4 lg:h-4 w-4 h-4 text-purple-600" />
                                <ArrowLeft className="lg:w-6 lg:h-6 w-4 h-4 text-purple-500" />
                                <ArrowLeft className="lg:w-8 lg:h-8 w-4 h-4 text-purple-400" />
                            </div>
                        </div>

                        {/* Crowd */}
                        <div className="text-center group lg:w-44 md:w-36 w-28">
                            <div className="relative flex flex-col items-center">
                                <div className="lg:w-32 lg:h-32 md:w-24 md:h-24 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-full flex items-center justify-center mb-6 group-hover:-rotate-6 transition-transform duration-300 shadow-2xl shadow-purple-500/30 relative">
                                    <Users className="lg:w-16 lg:h-16 md:w-12 md:h-12 w-8 h-8 text-white" />
                                    <div className="absolute lg:-top-1 lg:-left-1 -top-0.5 -left-0.5 lg:w-6 lg:h-6 w-4 h-4 bg-purple-400 rounded-full border-2 lg:border-4 border-black animate-bounce"></div>
                                    <div className="absolute lg:-bottom-2 lg:-right-1 -bottom-1 -right-0.5 lg:w-6 lg:h-6 w-4 h-4 bg-purple-300 rounded-full border-2 lg:border-4 border-black animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                </div>
                            </div>
                            <h3 className="lg:text-2xl text-lg font-bold text-purple-300 mb-2">Audience</h3>
                            <p className="lg:text-base text-xs text-gray-400">Engages & responds</p>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <div className="inline-flex items-center lg:gap-4 gap-2 px-8 py-4 bg-gradient-to-r from-purple-600/20 to-purple-500/20 border border-purple-400/30 rounded-full">
                            <TrendingUp className="lg:w-12 lg:h-12 w-6 h-6 text-purple-400" />
                            <span className="lg:text-xl text-xs font-semibold text-purple-300">Higher engagement = Better tips = Stronger community</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Testimonials Section */}
            <div className="relative py-20 bg-black">
                {/* <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-900/5 to-transparent"></div> */}
                <div className="relative max-w-7xl mx-auto px-6 pb-32">
                    <div className="text-center mb-16">
                        <h2 className="text-6xl font-bold mb-4">What DJs Are Saying</h2>
                        <p className="text-xl text-gray-400">Real experiences from real DJs</p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-gray-900/50 to-black/50 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20 flex flex-col h-full">
                            <div className="flex-grow">
                                <div className="flex items-center mb-6">

                                </div>
                                <Quote className="w-8 h-8 text-purple-400 mb-4" />
                                <p className="text-gray-300 leading-relaxed">
                                    DJ Social has really upped my professionalism, it consolidates many aspects of the profession and makes it easy to fulfill my clients wishes.
                                </p>
                            </div>
                            <div className="flex items-center mt-6 pt-6">
                                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-white font-bold">VO</span>
                                </div>
                                <div>
                                    <div className="font-semibold text-purple-300">Victor Ortiz</div>
                                    <div className="text-sm text-gray-400">Boston</div>
                                </div>
                            </div>
                        </div>

                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-gray-900/50 to-black/50 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20 flex flex-col h-full">
                            <div className="flex-grow">
                                <div className="flex items-center mb-6">

                                </div>
                                <Quote className="w-8 h-8 text-purple-400 mb-4" />
                                <p className="text-gray-300 leading-relaxed">
                                    I've used the software to increase my social media follower count!
                                </p>
                            </div>
                            <div className="flex items-center mt-6 pt-6">
                                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-white font-bold">DS</span>
                                </div>
                                <div>
                                    <div className="font-semibold text-purple-300">DJ Slick</div>
                                    <div className="text-sm text-gray-400">New York</div>
                                </div>
                            </div>
                        </div>

                        <div className="group p-8 rounded-2xl bg-gradient-to-br from-gray-900/50 to-black/50 border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20 md:col-span-2 lg:col-span-1">
                            <div className="flex items-center mb-6">
                                
                            </div>
                            <Quote className="w-8 h-8 text-purple-400 mb-4" />
                            <p className="text-gray-300 mb-6 leading-relaxed">
                                DJ social is a great app to connect the audience with the VJ/DJ, which allows the customers to make requests and dedications from the comfort of their space at the venue.  I’ve also booked future events from customers who have used the app.
                            </p>
                            <div className="flex items-center">
                                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-white font-bold">JM</span>
                                </div>
                                <div>
                                    <div className="font-semibold text-purple-300">Jack Millz</div>
                                    <div className="text-sm text-gray-400">Pittsburgh</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="relative py-20 bg-purple-900">
                <div className="relative max-w-4xl mx-auto text-center px-6">
                    <h2 className="text-4xl font-bold mb-6">Ready to transform your DJ experience?</h2>
                    <p className="text-xl text-gray-400 mb-10">Join other DJs who are already earning more and building stronger communities.</p>
                    <button
                        onClick={handleSignUp}
                        className="px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-500 text-white text-lg font-semibold rounded-full hover:from-purple-500 hover:to-purple-400 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/30"
                    >
                        Get Started Today
                    </button>
                </div>
        </div>

    </>
    );
}; 
